/*
Item: Container Components for collecting Cards in Drag'n'Drop in 
  Statistics.jsx, used for Rows only
Name: Container
Format: Code/Frontend component
*/

import React, { Component } from 'react';
// import update from 'immutability-helper'
import { DropTarget } from 'react-dnd';
import Card from './StructureCard';
import '../../styles/container.css';
// import uniqueId from 'lodash/uniqueId';

class Container extends Component {
  constructor(props) {
    super(props);
    // this.state = { cards: props.list };
    this.pushCard = this.props.pushCard;
    this.removeCard = this.props.removeCard;
    this.showOverlay = this.props.showOverlay;
    this.moveCard = this.props.moveCard;
    this.makeNestedList = this.props.makeNestedList;
    this.copyAll = this.props.copyAll;
  }

  render() {
    const cards = this.props.list;
    // console.log('PUSHCARD#3', this.copyAll);
    const {
      canDrop, isOver, connectDropTarget, header, popup, id, containerName, hasValue,
    } = this.props;
    const isActive = canDrop && isOver;
    const isDuplicate = !canDrop && isOver;
    const style = {
      minWidth: '226px', position: 'relative',
    };
    const showPaste = 'hidden';
    const backgroundColor = isActive ? 'lightgreen' : isDuplicate ? '#FFB3B3' : '#FFF';
    return connectDropTarget(
      <div className="card" style={{ ...style, backgroundColor }}>
        {typeof this.copyAll !== "undefined" && cards.length > 0
          ? (
            <div
              className="copyOverlayRow"
              style={{ visibility: { showPaste } }}
            >
              <i
                title="Kopie am Ende erstellen"
                style={{ color: '#999' }}
                className="pi pi-md-content-copy"
                onClick={() => this.copyAll(-1, containerName)}
              />
            </div>
          )
          : undefined
        }
        <span style={{ color: '#999', fontSize: '12px' }}>{header}</span>
        {cards.map((card, i) => (
          <Card
            key={card.id}
            activeFilter={card.activeFilter}
            activeRule={card.activeRule}
            showRules={card.showRules}
            index={i}
            listId={id}
            containerName={containerName}
            card={card}
            removeCard={this.removeCard}
            moveCard={this.moveCard}
            showOverlay={this.showOverlay}
          />
        ))}
      </div>,
    );
  }
}

const cardTarget = {
  drop(props, monitor, component) {
    const { id } = props;
    const { containerName } = props;
    const sourceObj = monitor.getItem();
    if (id !== sourceObj.listId) {
      component.pushCard(sourceObj.card, containerName);
    } else {
      const { makeNestedList } = props;
      const { list } = props;
      makeNestedList(containerName, list);
    }
    return {
      listId: id,
    };
  },
  canDrop(props, monitor) {
    const { list, id, unmoveable } = props;
    const dragItem = monitor.getItem();
    if (unmoveable) { // the container can never be dropped (key figures)
      return false;
    }
    if (id === dragItem.listId) { // does the item originate from the same container?
      return true;
    }
    if (list.some((item) => item.code === dragItem.card.code)) {
      // on external source, does the item already exist inside the container?
      return false;
    }
    /* // 2688
    if (dragItem.card.type === 'VALUE') {
      // is the dragged item a 'Merkmal' and this not a filter container?
      if (list) {
        // no double VALUEs => replace
        const strList = JSON.stringify(list);
        const hasNotValue = (strList.search(/"type":"VALUE"/) === -1);
        if (hasNotValue) console.log('PUSHCARD#9', 'double VALUEs');
        return hasNotValue;
      }
    }
    */ // 2688
    return true;
  },
};

export default DropTarget('CARD', cardTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
}))(Container);
